import "./valentine-bg.scss";

export default function ValentineBackground({ children }) {
  return (
    <div className="valentine-background">
      <div className="light one"></div>
      <div className="light two"></div>
      <div className="light three"></div>
      <div className="light four"></div>
      <div className="light five"></div>
      <div className="light six"></div>
      <div className="content">{children}</div>
    </div>
  );
}
